import { css, type Theme } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as timing from "@styles/emotion-styles/timing";

export const boxLink = css`
  padding: 0.75rem;
  margin-bottom: 1rem;

  &:active {
    .icon-right {
      margin-left: 2rem;
    }
  }
`;

export const userIcon = (theme: Theme) => css`
  margin-right: 1rem;
  color: ${theme.success.textBase};
`;

export const arrowIcon = (theme: Theme) => css`
  margin-left: 1rem;
  color: ${theme.success.textBase};
  transition: margin ${timing.fast} ${animations.easeOutCubic};
`;
